import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./FloatingBox.css";

export const FloatingBox = () => {
  const { t } = useTranslation();

  return (
      <div className="floatingBox__card wow slideInUp">
        <div className="d-flex justify-content-between align-items-center flex-column flex-sm-row gap-5">
          <h6 className="floatingBox__text">
            {t("floatingBox.text")}
          </h6>
          <Button
            className="card-effect__button"
            type="submit"
            href="#contact"
          >
            {t("floatingBox.button")}
          </Button>
        </div>
      </div>
  );
};
